import type { CSSProperties } from "react";

// One skeleton block. Sized by the caller so the placeholder matches the
// shape of what will replace it; hidden from assistive tech because the
// enclosing PageSkeleton already announces the loading state once.
//
// `variant` picks a class from the vocabulary shared with the PWA
// (dashboard.css §Skeletons). The default `bar` is the panel's original
// inline-sized block; `text`/`title` take their height from the line box
// (1lh), so they only need a width.
export type SkelVariant = "bar" | "text" | "title" | "pill" | "circle" | "media" | "card" | "btn";

type Props = {
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
  /** Shorthand for `variant="pill"`, kept for the existing call sites. */
  pill?: boolean;
  variant?: SkelVariant;
};

export function Skel({ width, height, pill, variant }: Props) {
  const v = variant ?? (pill ? "pill" : "bar");
  const style: CSSProperties = {};
  if (width !== undefined) style.width = width;
  if (height !== undefined) style.height = height;
  return <span className={`skel skel--${v}`} style={style} aria-hidden="true" />;
}
